<template>

	<div id="app">
		<!-- <HeadTop />
    <el-button
      type="primary"
      @click="to('super')"
    >超级管理员</el-button>
    <el-button
      type="primary"
      @click="to('jituan')"
    >集团</el-button>
    <el-button
      type="primary"
      @click="to('project')"
    >工程</el-button> -->
		<router-view />
	</div>
</template>
<script>
import HeadTop from './components/header.vue'
export default {
	components: {
		HeadTop
	},
	data () {
		return {

		}
	},
	created () {

	},
	methods: {
		to (val) {
			if (val == 'super') {
				this.$router.push({
					path: 'superadmincompany'
				})
			} else if (val == 'jituan') {
				this.$router.push({
					name: 'groupinfo'
				})
			} else if (val == 'project') {
				this.$router.push({
					name: 'projectmanager'
				})

			}
		}
	}
}
</script>
<style lang="scss">
* {
	padding: 0;
	margin: 0;
}

html,
body {
	height: 100%;
	width: 100%;
	min-height: 100%;
	background: url(./assets/img/bg.png);
}

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	width: 100%;
	min-height: 100%;
	font-size: 16px;
	color: white;
	height: 100%;

	.conBG {
		width: 95%;
		height: calc(100%-200px);
		margin: 0 auto;

		.menuList {
			margin-top: 20px;
			list-style-type: none;
			margin-bottom: 20px;

			li {
				float: left;
				color: white;
				width: 140px;
				height: 40px;
				line-height: 40px;
				cursor: pointer;
				background: #22386d;
				border-radius: 3px;
				text-align: center;
				margin-right: 20px;
				font-weight: bold;
				margin-top: 20px;
			}

			.active {
				background: #2ac1dc;
			}
		}
	}
}
</style>